export const es = {
    availability: {
        comingSoon: "Presentación próximamente...",
        unavailable: "Presentación no disponible.",
        unavailableMessage: "Esta presentación ya no se puede ver públicamente."
    },
    controls: {
        toggleMediaDescription: "Alternar la visualización de la descripción del contenido multimedia"
    },
    notFound: {
        message: "Las URL de presentación tienen el formato {{homeRoute}}/[:id de usuario]/[:token]",
        title: "Presentación no encontrada"
    }
};
